export default __webpack_public_path__ + "static/media/promise-2.a5547deb.svg";